<div *ngIf="address">

    <div *ngIf="addressLinesValues | arrayNotEmpty">
        <p *ngFor="let line of addressLinesValues">
            {{ line }}
        </p>
    </div>

    <div *ngIf="address.Ville as Ville">
        <p>{{ address.CodePostal }} {{ Ville.Libelle }}</p>
        <p>{{ Ville.Pays?.Libelle }}</p>
    </div>

</div>
